import { Card, CardContent, Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { ProjectType } from '../../../models/project';
import { FormRadioButtonGroup } from '../../../components/hook-form/form-radio-button-group.component';
import { useState } from 'react';
import { FormInput } from '../../../components/hook-form/form-input.component';

export const RecidentialCommunityForm = ({ isEdit, enableRequestField }: { isEdit?: boolean, enableRequestField?: boolean }) => {
  const [projectLotTypeValue, setprojectLotTypeValue] = useState<ProjectType>();
  const { watch } = useFormContext();
  const projectCommunityType = watch('projectCommunityType');

  if (
    projectCommunityType === ProjectType.ResidentialCommunity ||
    projectCommunityType === ProjectType?.CommunityScatteredLot
  ) {
    return (
      <Card elevation={0}>
        <CardContent style={{ display: 'flex', alignItems: 'start' }}>
          <Grid className="d-flex " style={{ width: '100%' }}>
            {projectCommunityType !== ProjectType?.CommunityScatteredLot && (
              <FormRadioButtonGroup
                name="projectLotType"
                labelKey="label"
                valueKey="value"
                disable={isEdit && !enableRequestField}
                optionData={[
                  { label: 'Multiple Lot', value: ProjectType.CommunityMultipleLot },
                  { label: 'Buildings', value: ProjectType.Buildings },
                ]}
                onValueChange={(value: ProjectType) => setprojectLotTypeValue(value)}
              />
            )}
            {(!isEdit || enableRequestField) &&
              (projectLotTypeValue === ProjectType.CommunityMultipleLot ||
                projectCommunityType === ProjectType?.CommunityScatteredLot) && (
                <div style={{ marginRight: 'auto', marginLeft: '15px' }}>
                  <FormInput name="multipleLotsCount" label="How many Lots" />
                </div>
              )}
          </Grid>
        </CardContent>
      </Card>
    );
  }
  return null;
};
